import type { Session } from 'types/Session'

// The dealer context we stamp onto every analytics event, regardless of which
// provider sends it. Amplitude and Kinesis share this so the two pipelines can be
// joined on the same attribute names.
export const dealerAnalyticsAttributes = (session?: Session | null, brand?: string) => ({
  dealerRemoteUuid: session?.remoteUuid ?? null,
  dealerName: session?.dealerName ?? null,
  dealerId: session?.dealerId ?? null,
  dealerState: session?.state ?? null,
  channel: session?.channel ?? null,
  brand: brand ?? null
})

// Kinesis auto-track attributes have to be strings, so blank values are dropped
// rather than sent along as "null".
export const dealerTrackerAttributes = (session?: Session | null, brand?: string): Record<string, string> => {
  const attributes = dealerAnalyticsAttributes(session, brand)

  return Object.entries(attributes).reduce<Record<string, string>>((tracked, [name, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      tracked[name] = String(value)
    }

    return tracked
  }, {})
}
